import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Avatar,
  Typography,
  Stack,
} from '@mui/material';
import {
  Edit as EditIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

const ProfilePage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    role: user?.role || 'admin',
  });

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleSave = () => {
    // TODO: プロフィール更新のAPI呼び出し
    console.log('プロフィール更新:', formData);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      name: user?.name || '',
      email: user?.email || '',
      role: user?.role || 'admin',
    });
    setIsEditing(false);
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        プロフィール
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 3 }}>
        {/* プロフィール画像セクション */}
        <Box sx={{ minWidth: 300 }}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Avatar
                sx={{
                  width: 120,
                  height: 120,
                  fontSize: '2rem',
                  mx: 'auto',
                  mb: 2,
                }}
              >
                {user?.name?.charAt(0) || 'A'}
              </Avatar>
              <Typography variant="h6" gutterBottom>
                {user?.name || '管理者'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {user?.role || 'Administrator'}
              </Typography>
            </CardContent>
          </Card>
        </Box>

        {/* 基本情報セクション */}
        <Box sx={{ flexGrow: 1 }}>
          <Card>
            <CardHeader
              title="基本情報"
              action={
                isEditing ? (
                  <Stack direction="row" spacing={1}>
                    <Button
                      onClick={handleSave}
                      startIcon={<SaveIcon />}
                      variant="contained"
                    >
                      保存
                    </Button>
                    <Button
                      onClick={handleCancel}
                      startIcon={<CancelIcon />}
                      variant="outlined"
                    >
                      キャンセル
                    </Button>
                  </Stack>
                ) : (
                  <Button
                    onClick={handleEdit}
                    startIcon={<EditIcon />}
                    variant="outlined"
                  >
                    編集
                  </Button>
                )
              }
            />
            <CardContent>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  label="名前"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                />
                <TextField
                  fullWidth
                  label="メールアドレス"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  disabled={!isEditing}
                  variant={isEditing ? 'outlined' : 'standard'}
                />
                <TextField
                  fullWidth
                  label="役職"
                  value={formData.role}
                  disabled={true}
                  variant="standard"
                  helperText="役職は管理者設定で変更できません"
                />
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfilePage; 